import React from 'react';
import { useNavigate } from 'react-router-dom';

const ProductCard = ({ product }) => {
  const navigate = useNavigate();

  return (
    <div
      onClick={() => navigate(`/product/${product._id}`)}
      className="group cursor-pointer"
    >
      {/* Color Block Image */}
      <div className="aspect-[3/4] mb-4 overflow-hidden bg-gray-100 relative">
        <div
          className="absolute inset-0 transition-transform duration-700 group-hover:scale-105"
          style={{ backgroundColor: product.colorBlock }}
        />
        {!product.inStock && (
          <div className="absolute inset-0 bg-white/80 flex items-center justify-center">
            <span className="text-sm font-bold tracking-wider">SOLD OUT</span>
          </div>
        )}
      </div>

      {/* Product Info */}
      <div className="space-y-1">
        <h3 className="text-sm font-bold tracking-wider group-hover:opacity-50 transition-opacity">
          {product.name}
        </h3>
        <p className="text-sm">${product.price}</p>
      </div>
    </div>
  );
};

export default ProductCard;
